import styled from "styled-components";

export const InvoiceHistoryWrapper = styled.div`
  .total-invoice-amount-label {
    margin: 16px;
  }
`;
